import { Link } from "react-router-dom";

import institucional01 from "../../images/service/Imagenes Full 2/VIDEO INSTITUCIONAL/DN4.png";
import institucional02 from "../../images/service/Imagenes Full 2/VIDEO INSTITUCIONAL/PRESEAS3.png";
import institucional03 from "../../images/service/Imagenes Full 2/VIDEO INSTITUCIONAL/DN2.png";

import comercial01 from "../../images/service/Imagenes Full 2/VIDEO COMERCIAL/CINEPOLIS1.png";
import comercial02 from "../../images/service/Imagenes Full 2/VIDEO COMERCIAL/DNT.png";
import comercial03 from "../../images/service/Imagenes Full 2/VIDEO COMERCIAL/ARCA.png";

import elements01 from "../../images/service/Imagenes Full 2/MOTION 3D/TUALI2.png";
import elements02 from "../../images/service/Imagenes Full 2/MOTION 3D/ACD1.png";
import elements03 from "../../images/service/Imagenes Full 2/MOTION 3D/TUALI 4.png";

import motion01 from "../../images/service/Imagenes Full 2/MOTION 2D/HKN EDF 2.png";
import motion02 from "../../images/service/Imagenes Full 2/MOTION 2D/PEDRO REPARTIDOR 1.png";
import motion03 from "../../images/service/Imagenes Full 2/MOTION 2D/SEGURIDA 4.png";

import chromas01 from "../../images/service/Imagenes Full 2/CHROMA/DATA SINCE3.png";
import chromas02 from "../../images/service/Imagenes Full 2/CHROMA/DATA SINCE4.png";
import chromas03 from "../../images/service/Imagenes Full 2/CHROMA/LEADERS AS TEACHERS 1.png";

import eventos01 from "../../images/service/Imagenes Full 2/VIDEO EVENTOS/EVENTOFIFA1.png";
import eventos02 from "../../images/service/Imagenes Full 2/VIDEO EVENTOS/EVENTOFIFA2.png";
import eventos03 from "../../images/service/Imagenes Full 2/VIDEO EVENTOS/EVENTOFIFA3.png";

import ia01 from "../../images/service/Imagenes Full 2/MOTION 2D/HKN EDF 2.png";
import ia02 from "../../images/service/Imagenes Full 2/MOTION 2D/HKN EDF 2.png";
import ia03 from "../../images/service/Imagenes Full 2/MOTION 2D/HKN EDF 2.png";

type GallerySectionProps = {
  slug: string;
};

const GALLERIES: Record<string, string[][]> = {
  institucional: [
    [institucional01, institucional01, institucional01, institucional01],
    [institucional02, institucional02, institucional02, institucional02],
    [institucional03, institucional03, institucional03, institucional03],
  ],

  comercial: [
    [comercial01, comercial01, comercial01, comercial01],
    [comercial02, comercial02, comercial02, comercial02],
    [comercial03, comercial03, comercial03, comercial03],
  ],

  "3d-elements": [
    [elements01, elements01, elements01, elements01],
    [elements02, elements02, elements02, elements02],
    [elements03, elements03, elements03, elements03],
  ],

  "motion-graphics": [
    [motion01, motion01, motion01, motion01],
    [motion02, motion02, motion02, motion02],
    [motion03, motion03, motion03, motion03],
  ],

  chromas: [
    [chromas01, chromas01, chromas01, chromas01],
    [chromas02, chromas02, chromas02, chromas02],
    [chromas03, chromas03, chromas03, chromas03],
  ],

  "eventos-empresariales": [
    [eventos01, eventos01, eventos01, eventos01],
    [eventos02, eventos02, eventos02, eventos02],
    [eventos03, eventos03, eventos03, eventos03],
  ],

  "trabajos-con-ia": [
    [ia01, ia01, ia01, ia01],
    [ia02, ia02, ia02, ia02],
    [ia03, ia03, ia03, ia03],
  ],
};

const GallerySection: React.FC<GallerySectionProps> = ({ slug }) => {
  const gallerySets = GALLERIES[slug] || GALLERIES.institucional;

  return (
    <div className="service-gallary ul_li_between mt-125">
      {gallerySets.map((set, index) => (
        <div className="single-item-image img-hove-effect" key={index}>
          <div className="xb-img">
            {set.map((img, i) => (
              <Link key={i} to={`/service-details/${slug}`}>
                <img src={img} alt="gallery" />
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default GallerySection;